import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
} from "@angular/core";
import { Observable } from "rxjs";
import { UntypedFormControl } from "@angular/forms";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { map, startWith } from "rxjs/operators";
import { ChipType } from "./chip-type.enum";
import { Tag } from "../../../../../codegen/out/types";

@Component({
  selector: "app-tag-select",
  templateUrl: "./tag-select.component.html",
  styleUrls: ["./tag-select.component.scss"],
  standalone: false,
})
export class TagSelectComponent implements OnInit, OnChanges {
  @Input() allAvailableTags: Tag[];
  filteredTags: Observable<string[]>;
  formControl = new UntypedFormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  bgClass = "bg-included";

  @ViewChild("tagInput") tagInput: ElementRef<HTMLInputElement>;

  @Input() title: string;
  @Input() selectedTags: string[] = [];
  @Input() selectedTypes: string[] = [];
  @Input() chipType: ChipType = ChipType.INCLUDED;
  @Output() updated = new EventEmitter<string[]>();

  ngOnInit() {
    if (this.chipType === ChipType.EXCLUDED) {
      this.bgClass = "bg-excluded";
    } else {
      this.bgClass = "bg-included";
    }

    this.updateFormControl();
  }

  ngOnChanges(): void {
    this.updateFormControl();
  }

  private updateFormControl(): void {
    this.filteredTags = this.formControl.valueChanges.pipe(
      startWith(""),
      map((value) => this.filterTagsBasedOnTypes(value))
    );
  }

  private filterTagsBasedOnTypes(value: any): string[] {
    const filterValue = value.toLowerCase();
    return this.allAvailableTags
      .filter((tag) => tag.name.toLowerCase().includes(filterValue))
      .map((tag) => tag.name);
  }

  add(event: MatChipInputEvent): void {
    if (this.addSelectedTag(event.value)) {
      event.input.value = "";
      this.formControl.setValue("");
      this.triggerUpdate();
    }
  }

  remove(tagToRemove: string): void {
    this.selectedTags = this.selectedTags.filter((tag) => tag !== tagToRemove);
    this.triggerUpdate();
  }

  private addSelectedTag(tag: string): boolean {
    if (
      !this.allAvailableTags.find((tagModel) => tagModel.name === tag) ||
      this.selectedTags.includes(tag)
    ) {
      return false;
    }
    this.selectedTags.push(tag);
    return true;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.addSelectedTag(event.option.value)) {
      this.tagInput.nativeElement.value = "";
      this.formControl.setValue("");
      this.triggerUpdate();
    }
  }

  private triggerUpdate() {
    this.updated.emit(this.selectedTags);
  }
}
